<template>
  <div class="home">
    <!-- 轮播图区域 -->
    <section class="hero-section">
      <div class="carousel-container">
        <div 
          v-for="(slide, index) in carouselSlides" 
          :key="index"
          class="carousel-slide"
          :class="{ active: currentSlide === index }"
          :style="{ backgroundImage: `url(${slide.image})` }">
          <div class="slide-content">
            <h1 class="slide-title">{{ slide.title }}</h1>
            <p class="slide-description">{{ slide.description }}</p>
            <button class="cta-button" @click="handleCTA">{{ slide.buttonText }}</button>
          </div>
        </div>
        
        <div class="carousel-nav">
          <button 
            v-for="(slide, index) in carouselSlides" 
            :key="index"
            :class="{ active: currentSlide === index }"
            @click="goToSlide(index)">
          </button>
        </div>
      </div>
    </section>

    <!-- 产品介绍区域 -->
    <section class="products-section">
      <div class="container">
        <h2 class="section-title">我们的产品</h2>
        <p class="section-subtitle">专业的数字化解决方案，助力企业快速发展</p>
        
        <div class="products-grid">
          <div v-for="product in products" :key="product.id" class="product-card">
            <!-- <div class="product-icon">
              <img :src="product.icon" :alt="product.name">
            </div> -->
            <h3 class="product-name">{{ product.name }}</h3>
            <p class="product-description">{{ product.description }}</p>
            <ul class="product-features">
              <li v-for="feature in product.features" :key="feature">{{ feature }}</li>
            </ul>
            <button class="product-btn" @click="learnMore">了解更多</button>
          </div>
        </div>
      </div>
    </section>

    <!-- 客户见证区域 -->
    <section class="testimonials-section">
      <div class="container">
        <h2 class="section-title">客户见证</h2>
        <p class="section-subtitle">听听我们客户的真实反馈</p>
        
        <div class="testimonials-grid">
          <div v-for="testimonial in testimonials" :key="testimonial.id" class="testimonial-card">
            <p class="testimonial-text">{{ testimonial.content }}</p>
            <div class="testimonial-author">
              <img :src="testimonial.avatar" :alt="testimonial.name" class="author-avatar">
              <div class="author-info">
                <div class="author-name">{{ testimonial.name }}</div>
                <div class="author-title">{{ testimonial.title }}</div>
                <div class="author-company">{{ testimonial.company }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 客户展示区域 -->
    <section class="clients-section">
      <div class="container">
        <h2 class="clients-title">我们服务的客户</h2>
        
        <div class="clients-container">
          <!-- 第一行 -->
          <div class="clients-row">
            <div class="clients-track">
              <div v-for="client in [...clientsRow1, ...clientsRow1]" :key="`row1-${client.id}`" class="client-logo">
                <img :src="client.logo" :alt="client.name">
              </div>
            </div>
          </div>
          
          <!-- 第二行 -->
          <div class="clients-row">
            <div class="clients-track clients-track-reverse">
              <div v-for="client in [...clientsRow2, ...clientsRow2]" :key="`row2-${client.id}`" class="client-logo">
                <img :src="client.logo" :alt="client.name">
              </div>
            </div>
          </div>
          
          <!-- 第三行 -->
          <div class="clients-row">
            <div class="clients-track">
              <div v-for="client in [...clientsRow3, ...clientsRow3]" :key="`row3-${client.id}`" class="client-logo">
                <img :src="client.logo" :alt="client.name">
              </div>
            </div>
          </div>
          
          <!-- 第四行 -->
          <!-- <div class="clients-row">
            <div class="clients-track clients-track-reverse">
              <div v-for="client in [...clientsRow4, ...clientsRow4]" :key="`row4-${client.id}`" class="client-logo">
                <img :src="client.logo" :alt="client.name">
              </div>
            </div>
          </div> -->
          
          <!-- 第五行 -->
          <!-- <div class="clients-row">
            <div class="clients-track">
              <div v-for="client in [...clientsRow5, ...clientsRow5]" :key="`row5-${client.id}`" class="client-logo">
                <img :src="client.logo" :alt="client.name">
              </div>
            </div>
          </div> -->
          
          <!-- 第六行 -->
          <!-- <div class="clients-row">
            <div class="clients-track clients-track-reverse">
              <div v-for="client in [...clientsRow6, ...clientsRow6]" :key="`row6-${client.id}`" class="client-logo">
                <img :src="client.logo" :alt="client.name">
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </section>

    <!-- 新闻中心区域 -->
    <section class="news-section">
      <div class="container">
        <h2 class="section-title">新闻中心</h2>
        <p class="section-subtitle">了解最新的行业动态和公司资讯</p>
        
        <div class="news-grid">
          <div v-for="news in newsItems" :key="news.id" class="news-card">
            <div class="news-image">
              <img :src="news.image" :alt="news.title">
            </div>
            <div class="news-content">
              <span class="news-category">{{ news.category }}</span>
              <h3 class="news-title">{{ news.title }}</h3>
              <p class="news-summary">{{ news.summary }}</p>
              <div class="news-meta">
                <span class="news-date">{{ news.date }}</span>
                <button class="read-more">阅读更多</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 免费试用区域 -->
    <section class="trial-section">
      <div class="container">
        <div class="trial-content">
          <h2 class="trial-title">立即开始免费试用</h2>
          <p class="trial-description">
            体验我们的专业解决方案，开启数字化转型之旅
          </p>
          
          <div class="trial-features">
            <div class="trial-feature">
              <span class="feature-icon">✓</span>
              <span>7天免费试用</span>
            </div>
            <div class="trial-feature">
              <span class="feature-icon">✓</span>
              <span>专业技术支持</span>
            </div>
            <div class="trial-feature">
              <span class="feature-icon">✓</span>
              <span>一对一服务指导</span>
            </div>
          </div>
          
          <button class="trial-button" @click="startTrial">立即申请试用</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  data() {
    return {
      currentSlide: 0,
      carouselTimer: null,
      carouselSlides: [
        {
          title: '本地生活团购SAAS系统',
          description: '帮助本地生活商家快速上架小红书/抖音团购方案，轻松获客增收',
          buttonText: '立即了解',
          action: 'xiaohongshu',
          image: 'https://www.tanmarket.cn/_nuxt/img/index_icon4.9198e72.png'
        },
        // {
        //   title: '微短剧平台解决方案',
        //   description: '为承制方和平台方提供完整的发行平台解决方案',
        //   buttonText: '查看详情',
        //   action: 'weiduanju',
        //   image: 'https://picsum.photos/1920/800?random=2'
        // },
        // {
        //   title: 'IPTV C2分发系统',
        //   description: '助力内容供应商快速发行至运营商播控平台，提供专业代运营服务',
        //   buttonText: '了解更多',
        //   action: 'iptv',
        //   image: 'https://picsum.photos/1920/800?random=3'
        // }
      ],
      products: [
        {
          id: 1,
          name: '本地生活团购SAAS系统',
          description: '专为本地生活商家打造的小红书团购管理平台',
          icon: 'https://picsum.photos/100/100?random=10',
          features: [
            '快速店铺搭建',
            '智能商品管理',
            '数据分析报表',
            '客户关系管理'
          ]
        },
        {
          id: 2,
          name: '微短剧平台解决方案',
          description: '完整的微短剧内容发行与管理解决方案',
          icon: 'https://picsum.photos/100/100?random=11',
          features: [
            '内容管理系统',
            '分发渠道管理',
            '版权保护机制',
            '收益分析统计'
          ]
        },
        {
          id: 3,
          name: 'IPTV C2分发系统',
          description: '专业的IPTV内容分发与运营管理平台',
          icon: 'https://picsum.photos/100/100?random=12',
          features: [
            '多渠道分发',
            '播控平台对接',
            '内容审核机制',
            '代运营服务'
          ]
        }
      ],
      testimonials: [
        {
          id: 1,
          content: '使用雪顶科技的小红书团购系统后，我们的店铺流量提升了300%，客户转化率显著提高。',
          name: '张经理',
          title: '运营总监',
          company: '某知名餐饮连锁',
          avatar: 'https://picsum.photos/60/60?random=20'
        },
        {
          id: 2,
          content: '使用雪顶的产品之前试了好几家的产品，业务需求上都不能满足，但是雪顶科技产品却能解决所有问题,微短剧系统帮助我们快速搭建了发行平台，大大缩短了项目上线时间。',
          name: '李总',
          title: 'CEO',
          company: '某影视制作公司',
          avatar: 'https://picsum.photos/60/60?random=21'
        },
        {
          id: 3,
          content: 'C2分发系统的专业性和稳定性令人印象深刻，为我们节省了大量运营成本。',
          name: '王主任',
          title: '技术主管',
          company: '某内容供应商',
          avatar: 'https://picsum.photos/60/60?random=22'
        }
      ],
      newsItems: [
        {
          id: 1,
          title: '雪顶科技坚持创新，加速产品研发与市场拓展',
          summary: '团队将持续发力技术研发、产品优化和市场推广，进一步巩固行业领先地位...',
          category: '公司动态',
          date: '2024-01-15',
          image: 'https://picsum.photos/300/200?random=30'
        },
        {
          id: 2,
          title: '小红书团购市场迎来新机遇，SAAS系统需求激增',
          summary: '随着社交电商的快速发展，越来越多的商家开始关注小红书团购业务...',
          category: '行业资讯',
          date: '2025-01-10',
          image: 'https://picsum.photos/300/200?random=31'
        },
        {
          id: 3,
          title: '微短剧行业标准化发展，技术平台成关键要素',
          summary: '微短剧作为新兴内容形式，正在成为数字娱乐行业的重要组成部分...',
          category: '行业洞察',
          date: '2024-01-05',
          image: 'https://picsum.photos/300/200?random=32'
        }
      ],
      clientsRow1: [
        { id: 1, name: '隐亮在线', logo: 'https://fc1tn.baidu.com/it/u=1787894281,3821191910&fm=202&mola=new&crop=v1' },
        { id: 2, name: '虎牙直播', logo: 'https://fc1tn.baidu.com/it/u=2272137436,3507810480&fm=202&mola=new&crop=v1' },
        { id: 3, name: '泰康人寿', logo: 'https://gips3.baidu.com/it/u=3491037646,3288886904&fm=3030&app=3030&size=re3,2&q=75&n=0&g=4n&f=JPEG&fmt=auto&maxorilen2heic=2000000?s=2DD4ED069FF068801F7C8CC60300D033' },
        { id: 4, name: '索菲亚', logo: 'https://t7.baidu.com/it/u=3757741410,634436923&fm=190&app=131&size=re3,2&q=75&n=0&g=4n&f=JPEG&fmt=auto&maxorilen2heic=2000000?s=6DEDAE46D79C899003C732360300004C' },
        { id: 5, name: '火花思维', logo: 'https://gips2.baidu.com/it/u=2812215542,4214337705&fm=3030&app=3030&size=re3,2&q=75&n=0&g=4n&f=JPEG&fmt=auto&maxorilen2heic=2000000?s=3357887616618B4B04AB6FAF0300B00E' },
        { id: 6, name: 'LEXUS', logo: 'https://gips1.baidu.com/it/u=2468661548,3363783114&fm=3030&app=3030&size=re3,2&q=75&n=0&g=4n&f=JPEG&fmt=auto&maxorilen2heic=2000000?s=6DDDAE4619D049CA5886727E02008078' }
      ],
      clientsRow2: [
        { id: 7, name: '生活家居', logo: 'https://gips0.baidu.com/it/u=2135740527,3785455944&fm=3030&app=3030&size=re3,2&q=75&n=0&g=4n&f=JPEG&fmt=auto&maxorilen2heic=2000000?s=36F7E83695A1590B0854F2F40300403D' },
        { id: 8, name: '微博', logo: 'https://t8.baidu.com/it/u=1739231673,1023572136&fm=217&app=126&size=re3,2&q=75&n=0&g=4n&f=PNG&fmt=auto&maxorilen2heic=2000000?s=A7D7A87646312D982483FFFB0300801D' },
        { id: 9, name: '大陆期货', logo: 'https://t7.baidu.com/it/u=3338377718,161067460&fm=190&app=131&size=re3,2&q=75&n=0&g=4n&f=JPEG&fmt=auto&maxorilen2heic=2000000?s=7B678856C4ACA91314A72FED0300701E' },
        { id: 10, name: '火花思维', logo: 'https://gips2.baidu.com/it/u=2812215542,4214337705&fm=3030&app=3030&size=re3,2&q=75&n=0&g=4n&f=JPEG&fmt=auto&maxorilen2heic=2000000?s=3357887616618B4B04AB6FAF0300B00E' },
        { id: 11, name: 'LEXUS', logo: 'https://gips1.baidu.com/it/u=2468661548,3363783114&fm=3030&app=3030&size=re3,2&q=75&n=0&g=4n&f=JPEG&fmt=auto&maxorilen2heic=2000000?s=6DDDAE4619D049CA5886727E02008078' },
        { id: 12, name: '携程', logo: 'https://gips2.baidu.com/it/u=4224907529,1020364887&fm=3030&app=3030&size=re3,2&q=75&n=0&g=4n&f=JPEG&fmt=auto&maxorilen2heic=2000000?s=8962DC16873069824ECB81460200C0B3' }
      ],
      clientsRow3: [
        { id: 13, name: '量子之歌', logo: 'https://t8.baidu.com/it/u=3306310439,1588439510&fm=74&app=80&size=f256,256&n=0&f=JPEG&fmt=auto?s=F805307245406FE91065CCC60000C0B2&sec=1752426000&t=18b5b630f19c65e7fbfbd7b7ab00ece6' },
        { id: 14, name: '主见', logo: 'https://dss2.bdstatic.com/8_V1bjqh_Q23odCf/pacific/1993604216.jpg?x=0&y=0&h=150&w=242&vh=150.00&vw=242.00&oh=150.00&ow=242.00' },
        { id: 15, name: 'CAS智慧零售', logo: 'https://t7.baidu.com/it/u=2246211778,41302437&fm=74&app=80&size=f256,256&n=0&f=JPEG&fmt=auto?s=6BA51262D8DF47E954F428EB0300C022&sec=1752426000&t=c5035ffa044c0d8c1b665c5db57076ba' },
        { id: 16, name: '嘉民保险', logo: 'https://gips0.baidu.com/it/u=3800771363,611710811&fm=3030&app=3030&size=re3,2&q=75&n=0&g=4n&f=JPEG&fmt=auto&maxorilen2heic=2000000?s=0873CC1287296D09004518D6020010B2' },
        { id: 17, name: '少年得到', logo: 'https://gimg3.baidu.com/search/src=https%3A%2F%2Favatar.bdstatic.com%2Fit%2Fu%3D731117728%2C3161648875%26fm%3D3012%26app%3D3012%26autime%3D1749471676%26size%3Db360%2C360&refer=http%3A%2F%2Fwww.baidu.com&app=2021&size=w931&n=0&g=0n&q=75&fmt=auto?sec=1752426000&t=a627ea53d6a394e24f2f240918194cbc' },
        { id: 18, name: '田木伟', logo: 'https://img-website.huaerai.cn/storage/uploads/20241111/96e794287a45617d7ac77c8286947f68.jpg' },
      ]
      // clientsRow4: [
      //   { id: 19, name: '南京网络信息', logo: 'https://picsum.photos/120/60?random=119' },
      //   { id: 20, name: '聚优', logo: 'https://picsum.photos/120/60?random=120' },
      //   { id: 21, name: '中创商学', logo: 'https://picsum.photos/120/60?random=121' },
      //   { id: 22, name: '数年的口袋', logo: 'https://picsum.photos/120/60?random=122' },
      //   { id: 23, name: '腾讯', logo: 'https://picsum.photos/120/60?random=123' },
      //   { id: 24, name: '阿里巴巴', logo: 'https://picsum.photos/120/60?random=124' }
      // ],
      // clientsRow5: [
      //   { id: 25, name: '小叶子', logo: 'https://picsum.photos/120/60?random=125' },
      //   { id: 26, name: '有民智信', logo: 'https://picsum.photos/120/60?random=126' },
      //   { id: 27, name: '必要', logo: 'https://picsum.photos/120/60?random=127' },
      //   { id: 28, name: '小黄蜂', logo: 'https://picsum.photos/120/60?random=128' },
      //   { id: 29, name: 'QM俱佳家居', logo: 'https://picsum.photos/120/60?random=129' },
      //   { id: 30, name: '百度', logo: 'https://picsum.photos/120/60?random=130' }
      // ],
      // clientsRow6: [
      //   { id: 31, name: 'UNI3Y', logo: 'https://picsum.photos/120/60?random=131' },
      //   { id: 32, name: '广州优质生活集团', logo: 'https://picsum.photos/120/60?random=132' },
      //   { id: 33, name: '天天拍车', logo: 'https://picsum.photos/120/60?random=133' },
      //   { id: 34, name: '先环国际', logo: 'https://picsum.photos/120/60?random=134' },
      //   { id: 35, name: '波士顿', logo: 'https://picsum.photos/120/60?random=135' },
      //   { id: 36, name: 'RHB', logo: 'https://picsum.photos/120/60?random=136' }
      // ]
    }
  },
  mounted() {
    this.startCarousel()
  },
  beforeDestroy() {
    this.stopCarousel()
  },
  methods: {
    startCarousel() {
      this.carouselTimer = setInterval(() => {
        this.nextSlide()
      }, 5000)
    },
    stopCarousel() {
      if (this.carouselTimer) {
        clearInterval(this.carouselTimer)
      }
    },
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.carouselSlides.length
    },
    goToSlide(index) {
      this.currentSlide = index
      this.stopCarousel()
      this.startCarousel()
    },
    handleCTA() {
      this.$router.push('/products')
    },
    learnMore() {
      this.$router.push('/products')
    },
    startTrial() {
      alert('免费试用申请功能开发中，请联系客服：400-888-8888')
    }
  }
}
</script>

<style scoped>
.home {
  min-height: 100vh;
}

/* 轮播图样式 */
.hero-section {
  position: relative;
  height: 60vh;
  overflow: hidden;
}

.carousel-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.carousel-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

.carousel-slide.active {
  opacity: 1;
}

.carousel-slide::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* background: rgba(0, 0, 0, 0.4); */
}

.slide-content {
  position: relative;
  text-align: center;
  color: #333;
  max-width: 800px;
  padding: 0 20px;
  z-index: 1;
}

.slide-title {
  font-size: 3.5rem;
  font-weight: bold;
  margin-bottom: 20px;
  animation: slideInUp 1s ease-out;
}

.slide-description {
  font-size: 1.4rem;
  margin-bottom: 30px;
  line-height: 1.6;
  animation: slideInUp 1s ease-out 0.2s both;
}

.cta-button {
  background: #3470ff;
  color: white;
  border: 2px solid #3470ff;
  padding: 18px 45px;
  font-size: 1.2rem;
  font-weight: 600;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  animation: slideInUp 1s ease-out 0.4s both;
}

.cta-button:hover {
  background: transparent;
  color: white;
  border-color: white;
  transform: translateY(-3px);
  box-shadow: 0 12px 30px rgba(52, 112, 255, 0.4);
}

.carousel-nav {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 15px;
}

.carousel-nav button {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.5);
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
}

.carousel-nav button.active {
  background: white;
  border-color: white;
}

/* 通用样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  font-size: 2.5rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
  color: #2c3e50;
}

.section-subtitle {
  font-size: 1.2rem;
  text-align: center;
  color: #666;
  margin-bottom: 60px;
  line-height: 1.6;
}

/* 产品介绍样式 */
.products-section {
  padding: 100px 0;
  background: #f8f9fa;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
}

.product-card {
  background: white;
  padding: 40px 30px;
  border-radius: 20px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.product-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
}

.product-icon img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-bottom: 25px;
}

.product-name {
  font-size: 1.5rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 15px;
}

.product-description {
  color: #666;
  line-height: 1.6;
  margin-bottom: 25px;
}

.product-features {
  list-style: none;
  padding: 0;
  margin-bottom: 30px;
}

.product-features li {
  padding: 8px 0;
  color: #555;
  position: relative;
  padding-left: 20px;
}

.product-features li::before {
  content: '✓';
  margin-right: 10px;
  /* position: absolute; */
  /* left: 0; */
  color: #3470ff;
  font-weight: bold;
}

.product-btn {
  background: #3470ff;
  color: white;
  border: 2px solid #3470ff;
  padding: 14px 32px;
  border-radius: 50px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 15px;
}

.product-btn:hover {
  background: transparent;
  color: #3470ff;
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(52, 112, 255, 0.3);
}

/* 客户反馈样式 */
.testimonials-section {
  padding: 100px 0;
  background: white;
}

.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
}

.testimonial-card {
  background: #f8f9fa;
  padding: 40px 30px;
  border-radius: 20px;
  position: relative;
}

.testimonial-card::before {
  content: "\201C";
  position: absolute;
  top: -10px;
  left: 30px;
  font-size: 4rem;
  color: #3470ff;
  font-family: serif;
}

.testimonial-text {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #444;
  margin-bottom: 30px;
  font-style: italic;
}

.testimonial-author {
  display: flex;
  align-items: center;
  gap: 15px;
}

.author-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
}

.author-name {
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 5px;
}

.author-title {
  color: #666;
  font-size: 0.9rem;
  margin-bottom: 3px;
}

.author-company {
  color: #999;
  font-size: 0.9rem;
}

/* 客户展示区域 */
.clients-section {
  padding: 100px 0;
  background: white;
  text-align: center;
}

.clients-title {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 60px;
  color: #2c3e50;
}

.clients-container {
  max-width: 1400px;
  margin: 0 auto;
  overflow: hidden;
}

.clients-row {
  margin-bottom: 30px;
  overflow: hidden;
  width: 100%;
}

.clients-track {
  display: flex;
  gap: 60px;
  width: fit-content;
  animation: scrollRight 30s linear infinite;
}

.clients-track-reverse {
  animation: scrollLeft 30s linear infinite;
}

.client-logo {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
  width: 160px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.client-logo:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.client-logo img {
  max-width: 140px;
  max-height: 60px;
  width: auto;
  height: auto;
  object-fit: contain;
  opacity: 0.8;
  transition: opacity 0.3s ease;
}

.client-logo:hover img {
  opacity: 1;
}

/* 新闻中心样式 */
.news-section {
  padding: 100px 0;
  background: #f8f9fa;
}

.news-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
}

.news-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.news-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
}

.news-image img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.news-content {
  padding: 25px;
}

.news-category {
  background: #3470ff;
  color: white;
  padding: 6px 16px;
  border-radius: 50px;
  font-size: 0.85rem;
  font-weight: 600;
}

.news-title {
  font-size: 1.3rem;
  font-weight: bold;
  color: #2c3e50;
  margin: 15px 0;
  line-height: 1.4;
}

.news-summary {
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
}

.news-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.news-date {
  color: #999;
  font-size: 0.9rem;
}

.read-more {
  background: none;
  border: 2px solid #3470ff;
  color: #3470ff;
  padding: 10px 20px;
  border-radius: 50px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.3s ease;
}

.read-more:hover {
  background: #3470ff;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(52, 112, 255, 0.3);
}

/* 免费试用样式 */
.trial-section {
  padding: 120px 0;
  background: linear-gradient(135deg, #3470ff 0%, #2550d9 100%);
  color: white;
  text-align: center;
}

.trial-title {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 20px;
}

.trial-description {
  font-size: 1.3rem;
  margin-bottom: 40px;
  opacity: 0.9;
}

.trial-features {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-bottom: 40px;
  flex-wrap: wrap;
}

.trial-feature {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.1rem;
}

.feature-icon {
  background: rgba(255, 255, 255, 0.2);
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.trial-button {
  background: white;
  color: #3470ff;
  border: 3px solid white;
  padding: 20px 55px;
  font-size: 1.3rem;
  font-weight: 700;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.trial-button:hover {
  background: transparent;
  color: white;
  transform: translateY(-4px);
  box-shadow: 0 15px 35px rgba(255, 255, 255, 0.2);
}

/* 动画 */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes scrollRight {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

@keyframes scrollLeft {
  0% {
    transform: translateX(-50%);
  }
  100% {
    transform: translateX(0);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .slide-title {
    font-size: 2.5rem;
  }
  
  .slide-description {
    font-size: 1.1rem;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .products-grid,
  .testimonials-grid,
  .news-grid {
    grid-template-columns: 1fr;
  }
  
  .trial-features {
    flex-direction: column;
    gap: 20px;
  }
  
  .product-card,
  .testimonial-card,
  .news-card {
    margin: 0 10px;
  }

  .clients-title {
    font-size: 2rem;
    margin-bottom: 40px;
  }

  .clients-track {
    gap: 30px;
  }

  .client-logo {
    height: 60px;
    width: 120px;
  }

  .client-logo img {
    max-width: 100px;
    max-height: 40px;
  }
}
</style> 
 